import 'mapbox-gl/dist/mapbox-gl.css';
import { MAPBOX_ACCESS_TOKEN } from './const';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
export let mapboxgl: typeof import('mapbox-gl');

if (process.browser) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  mapboxgl = require('mapbox-gl');
  mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
}
